import ACLStore from "lib/aclStore";
import { ENABLE_GLOBAL_HEADER_ON_MULTIPLE_SCREENS } from "Constants/permissionConstants";

export const isGlobalHeaderOnMultipleScreensEnabled = () =>
  ACLStore.can(ENABLE_GLOBAL_HEADER_ON_MULTIPLE_SCREENS);
